webpackJsonp([35783957827783],{

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(261),
	    toInteger = __webpack_require__(196);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.take([1, 2, 3]);
	 * // => [1]
	 *
	 * _.take([1, 2, 3], 2);
	 * // => [1, 2]
	 *
	 * _.take([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.take([1, 2, 3], 0);
	 * // => []
	 */
	function take(array, n, guard) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = take;


/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(48);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CardImage = __webpack_require__(60);
	
	var _CardImage2 = _interopRequireDefault(_CardImage);
	
	var _Contents = __webpack_require__(18);
	
	__webpack_require__(269);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutMe = function (_Component) {
	  _inherits(AboutMe, _Component);
	
	  function AboutMe() {
	    _classCallCheck(this, AboutMe);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AboutMe.prototype.render = function render() {
	    var staticData = this.context.staticData;
	    var _props = this.props,
	        imageContentID = _props.imageContentID,
	        paragraphContentID = _props.paragraphContentID;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'Atrakeur-AboutMe' },
	      _react2.default.createElement(_CardImage2.default, { contentID: imageContentID, text: '', rounded: true, className: 'Atrakeur-AboutMe-Image' }),
	      _react2.default.createElement(_Contents.Paragraph, { contentID: paragraphContentID, className: 'Atrakeur-AboutMe-Paragraph ' })
	    );
	  };
	
	  return AboutMe;
	}(_react.Component);
	
	AboutMe.contextTypes = {
	  staticData: _propTypes2.default.array
	};
	exports.default = AboutMe;
	module.exports = exports['default'];

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(28);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _take = __webpack_require__(268);
	
	var _take2 = _interopRequireDefault(_take);
	
	var _map = __webpack_require__(73);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _ResponsiveGrid = __webpack_require__(15);
	
	var _Link = __webpack_require__(17);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _index = __webpack_require__(35);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Contents = __webpack_require__(18);
	
	var _CardImage = __webpack_require__(60);
	
	var _CardImage2 = _interopRequireDefault(_CardImage);
	
	var _CardText = __webpack_require__(84);
	
	var _CardText2 = _interopRequireDefault(_CardText);
	
	var _AboutMe = __webpack_require__(206);
	
	var _AboutMe2 = _interopRequireDefault(_AboutMe);
	
	var _BlogPostExcerpt = __webpack_require__(59);
	
	var _BlogPostExcerpt2 = _interopRequireDefault(_BlogPostExcerpt);
	
	var _ReadMoreButton = __webpack_require__(36);
	
	var _ReadMoreButton2 = _interopRequireDefault(_ReadMoreButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _gatsbyPluginPageTransitions2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Atrakeur-Page' },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement('meta', { charSet: 'utf-8' }),
	        _react2.default.createElement(
	          'title',
	          null,
	          'Atrakeur: DIY, Mod\xE9lisme et Web'
	        )
	      ),
	      _react2.default.createElement(_index2.default, {
	        contentID: 'index_title',
	        size: 'large'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'Atrakeur-Content' },
	        _react2.default.createElement(
	          _ResponsiveGrid.ResponsiveContainer,
	          { className: 'Atrakeur-Home', white: true, withMargin: true, withPadding: true },
	          _react2.default.createElement(
	            _ResponsiveGrid.Cell,
	            { colSpanDesktop: '6', colSpanTablet: '4', colSpanMobile: '4' },
	            _react2.default.createElement(_Contents.Paragraph, { contentID: 'index_goal', className: 'Atrakeur-Home-Goal' })
	          ),
	          _react2.default.createElement(
	            _ResponsiveGrid.Cell,
	            { colSpanDesktop: '3', colSpanTablet: '4', colSpanMobile: '4' },
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/blog/web' },
	              _react2.default.createElement(_CardImage2.default, { contentID: 'index_web', size: 'medium', hoverable: true })
	            )
	          ),
	          _react2.default.createElement(
	            _ResponsiveGrid.Cell,
	            { colSpanDesktop: '3', colSpanTablet: '4', colSpanMobile: '4' },
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/blog/diy' },
	              _react2.default.createElement(_CardImage2.default, { contentID: 'index_diy', size: 'medium', hoverable: true })
	            )
	          ),
	          false && _react2.default.createElement(
	            _ResponsiveGrid.Cell,
	            { colSpanDesktop: '2', colSpanTablet: '4', colSpanMobile: '4' },
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/blog/flight' },
	              _react2.default.createElement(_CardImage2.default, { contentID: 'index_flight', size: 'medium', hoverable: true })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _ResponsiveGrid.ResponsiveContainer,
	          { className: 'Atrakeur-Home', withMarginHor: true },
	          _react2.default.createElement(
	            _ResponsiveGrid.Cell,
	            { colSpanDesktop: '4', colSpanTablet: '4', colSpanMobile: '4' },
	            _react2.default.createElement(
	              _ResponsiveGrid.Cell,
	              { white: true, withPadding: true },
	              _react2.default.createElement(_Contents.Paragraph, { contentID: 'index_work', className: 'Atrakeur-Home-Welcome text-centered' })
	            ),
	            (0, _map2.default)((0, _take2.default)(data.allContentfulBlogPost.edges, 2), function (_ref2) {
	              var post = _ref2.node;
	              return _react2.default.createElement(_BlogPostExcerpt2.default, { post: post, disableMarginHor: true, key: post.id });
	            })
	          ),
	          _react2.default.createElement(
	            _ResponsiveGrid.Cell,
	            { colSpanDesktop: '2', colSpanTablet: '4', colSpanMobile: '4' },
	            _react2.default.createElement(
	              _ResponsiveGrid.Cell,
	              { withPadding: true, white: true },
	              _react2.default.createElement(_AboutMe2.default, { imageContentID: 'index_about', paragraphContentID: 'index_about' }),
	              _react2.default.createElement(
	                _ReadMoreButton2.default,
	                { to: '/aboutme' },
	                'A propos...'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-7049415271e4db3e7160.js